import { render, staticRenderFns } from "./CustomFieldGroupForm.vue?vue&type=template&id=a291cb8c&scoped=true"
import script from "./CustomFieldGroupForm.vue?vue&type=script&lang=ts"
export * from "./CustomFieldGroupForm.vue?vue&type=script&lang=ts"
import style0 from "./CustomFieldGroupForm.vue?vue&type=style&index=0&id=a291cb8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a291cb8c",
  null
  
)

export default component.exports